import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import HeaderBackground from "../../../common/SubpagesBGimage";

function CoreFaculty() {
  const [selectedStaffId, setSelectedStaffId] = useState(null);
  const [hoverPosition, setHoverPosition] = useState({
    top: "50%",
    left: "50%",
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const location = useLocation();
  const routeNames = {
    "/people/core-faculty": { menuName: "The People", subMenuName: "Core Faculty" },
  };

  const { menuName, subMenuName } =
    location.state || routeNames[location.pathname] || {};

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const { CoreFacultyDetails } = useSelector(
    (state) => state?.CorefacultysReducer
  );

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setHoverPosition({ top: `${y}px`, left: `${x}px` });
  };


  return (
    <>
      <div id="smooth-content ">
      <main className="main-bg blog-wrap ">
        <HeaderBackground
          menuName={menuName}
          subMenuName={subMenuName}
          handleMenuToggle={handleMenuToggle}
        />
        <div className="container core-fac ">
          <h1 className="submenu-heading-text core-faculty core-fac-heading-res fw-300  heading-submenu-res overall-submenu-heading">
            Core Faculty
          </h1>
          <div className="row mt-30">
            {CoreFacultyDetails &&
              CoreFacultyDetails.map((faculty) => (
                <React.Fragment key={faculty.id}>
                  <div className="col-md-3 mb-20 mt-10">
                    <div className="core-card">
                      <div
                        className={`card-container card-ress ${
                          selectedStaffId === faculty.id ? "selected" : ""
                        }`}
                      >
                        <div
                          className="content-3"
                          
                          onMouseMove={handleMouseMove}
                        >
                          <img
                            src={faculty.staff_image}
                            alt={faculty.staff_name}
                            className="core-faculty"
                            loading="lazy"
                            style={{ cursor: "pointer" ,width: '100%', height: 'auto' }}
                          />
                          <h6 className="main-color fw-500 core-texts">
                            {faculty.staff_name}
                          </h6>
                          <p className="fw-400 core-faculty-text">
                            {faculty.designation}
                          </p>
                        
                        </div>
                      </div>
                    </div>
                  </div>
                  {selectedStaffId === faculty.id && (
                    <div className="col-md-12">
                      <div className="card-description-4 visible">
                        <p className="staff-description">
                          {faculty.description}
                        </p>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
          </div>


          {/*
          Descriptions for each card , description must be given by the client

          <div className="description-wrapper">
            {CoreFacultyDetails &&
              CoreFacultyDetails.map((faculty) => (
                <div
                  className={`card-description-4 ${
                    selectedStaffId === faculty.id ? "visible" : "hidden"
                  }`}
                  key={faculty.id}
                >
                  <p className="staff-description">{faculty.description}</p>
                </div>
              ))}
          </div> */}
        </div>
      </main>
      <SideNavigation
        key={menuName}
        isMenuOpen={isMenuOpen}
        handleMenuToggle={handleMenuToggle}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        defaultOpenSubMenu={menuName}
      />
    </div>
    </>
  
  );
}

export default CoreFaculty;
